// Shared helpers for the School Portfolios (Portfolio Owner) experience.

export const API = process.env.REACT_APP_BACKEND_URL;

// 3-band portfolio risk scale (Master-Prompt Stage B, 80/60). Dirk approved Oct 4, 2026.
// Backend now emits 3-band keys; legacy keys kept only for old cached payloads.
const BAND3 = {
  healthy: { label: "Healthy", bg: "#f0fdf4", fg: "#166534", dot: "#16a34a" },
  caution: { label: "Caution", bg: "#fffbeb", fg: "#92400e", dot: "#d97706" },
  high_risk: { label: "High Risk", bg: "#fef2f2", fg: "#991b1b", dot: "#dc2626" },
  no_data: { label: "No Data", bg: "#f8fafc", fg: "#475569", dot: "#cbd5e1" },
};
const LEGACY_TO_BAND = {
  strong: "healthy", stable: "healthy", healthy: "healthy",
  moderate_risk: "caution", caution: "caution",
  high_risk: "high_risk", immediate_attention: "high_risk",
  no_data: "no_data",
};
export const RISK_BADGE = BAND3;

// 80/60 band from a raw score (preferred — exact, avoids the 'stable straddles 80' issue).
export const band = (score) =>
  score === null || score === undefined || score === "" || Number.isNaN(Number(score))
    ? "no_data"
    : Number(score) >= 80 ? "healthy" : Number(score) >= 60 ? "caution" : "high_risk";
export const bandMeta = (score) => BAND3[band(score)];
export const RISK_FILTER_OPTIONS = [
  { value: "all", label: "All Risk Levels" },
  { value: "healthy", label: "Healthy" },
  { value: "caution", label: "Caution" },
  { value: "high_risk", label: "High Risk" },
  { value: "no_data", label: "No Data" },
];

export const PORTFOLIO_TYPE_LABELS = {
  authorizer_portfolio: "Authorizer Portfolio",
  charter_network: "Charter Network",
  cmo_emo: "CMO / EMO",
  district_regional_operator: "District / Regional Operator",
  consultant_advisor: "Consultant / Advisor",
  "589_labs_internal": "589 Labs (Internal)",
  other: "Other",
};

export const riskMeta = (level) => BAND3[LEGACY_TO_BAND[String(level || "").toLowerCase()] || "no_data"];

// Canonical 8-pillar order (matches the diagnostic engine).
export const PILLAR_ORDER = [
  { id: "instruction", name: "Instruction" },
  { id: "admin_leadership", name: "Administrative Leadership" },
  { id: "fiscal", name: "Fiscal" },
  { id: "governance", name: "Governance" },
  { id: "compliance", name: "Compliance" },
  { id: "student_perf", name: "Student Performance" },
  { id: "cmo_emo", name: "School Management" },
  { id: "mission", name: "Mission and Key Design Elements" },
];

export const fmtScore = (s) => (s === null || s === undefined ? "—" : Number(s).toFixed(1));

export const licenseLabel = (status) =>
  (status || "unknown").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const fmtDate = (v) => {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
};
